/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkTimerecordtype } from '../models/work-timerecordtype';

@Injectable({ providedIn: 'root' })
export class WorkTimerecordtypesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `timerecordtypesV1ControllerFindAllForAbsences()` */
  static readonly TimerecordtypesV1ControllerFindAllForAbsencesPath = '/v1/timerecordtypes/forAbsences';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `timerecordtypesV1ControllerFindAllForAbsences()` instead.
   *
   * This method doesn't expect any request body.
   */
  timerecordtypesV1ControllerFindAllForAbsences$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkTimerecordtype>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTimerecordtypesService.TimerecordtypesV1ControllerFindAllForAbsencesPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkTimerecordtype>>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `timerecordtypesV1ControllerFindAllForAbsences$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  timerecordtypesV1ControllerFindAllForAbsences(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkTimerecordtype>> {
    return this.timerecordtypesV1ControllerFindAllForAbsences$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkTimerecordtype>>): Array<WorkTimerecordtype> => r.body)
    );
  }

}
